"use strict";module.exports=function(r,t){var n=t===Object(t)?function(r){return t[r]}:t;return function(t){return String(t).replace(r,n)}};